var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"viewer-container"},[_c('div',{ref:"viewer",staticClass:"pdfViewer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }